<template>
  <GenericStep v-bind="$attrs">
    <div
      v-for="passport of peParty.passports"
      :key="passport.id"
      class="mb-12"
    >
      <PassportCard
        :item="passport"
      />
    </div>

    <SectionAdderLine
      section="Passport"
      :has-new-section="pePassportCardHasNewSection"
      @on-add="pePassportCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import PassportCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/PassportCard.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'PassportsStep',

  components: {
    GenericStep,
    PassportCard,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.passports
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
      'pePassportCardHasNewSection',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'pePassportCardAddSection',
    ]),
  },
}
</script>
